<template>
  <v-container fluid>
    <v-form ref="form" @submit.prevent="save(false)">
      <v-row>
        <form-header :title="isEditing ?'Modifica sottocategoria prodotto' : 'Nuova sottocategoria prodotto'"
                     @back="$router.replace('/subcategories')" @saveback="save(true)" :loading="loading"></form-header>

        <v-col cols="12" lg="5">
          <h4>Copertina</h4>
          <v-img color="grey-darken-4" class="rounded elevation-2 cursor-pointer" :src="cover" width="100%" :aspect-ratio="16/9" @click="fileInput!.click()">
            <div class="w-100 h-100 d-flex justify-center align-center">
              <v-icon icon="mdi-attachment" color="white" :size="80"></v-icon>
            </div>
          </v-img>
        </v-col>
        <v-col cols="12" class="py-0"></v-col>
        <v-col cols="12" lg="6">
          <v-text-field
              label="Nome*"
              v-model="editingItem.name.it"
              :rules="[rules.required]"
          ></v-text-field>
        </v-col>


        <form-footer @back="$router.replace('/subcategories')" @saveback="save(true)" :loading="loading"></form-footer>

        <input ref="fileInput" type="file" style="width: 0; height: 0; visibility: hidden" accept=".jpeg, .jpg, .png" @change="onFileChange">
      </v-row>
    </v-form>
  </v-container>
</template>

<script lang="ts">
import utils from "../utils";
import rules from "../utils/rules";
import FormHeader from "@/components/FormHeader.vue";
import FormFooter from "@/components/FormFooter.vue";
import {computed, inject, onMounted, ref, useTemplateRef} from "vue";
import type {Auth} from "@/plugins/auth.ts";
import {type Messages, Msg} from "@/plugins/messages.ts";
import type {Globals} from "@/plugins/globals.ts";
import {useRoute, useRouter} from "vue-router";
import api from "@/api";
import {VForm} from "vuetify/components";
import type {Subcategory} from "@/models.ts";
export default {
  components: {FormFooter, FormHeader},
  setup() {
    const auth = inject('auth') as Auth
    const messages = inject('messages') as Messages
    const globals = inject('globals') as Globals
    const route = useRoute()
    const router = useRouter()
    const form = useTemplateRef<typeof VForm>('form')
    const loading = ref(false)

    const file = ref<File|undefined>()
    const fileInput = useTemplateRef<HTMLInputElement>('fileInput')

    const editingItem = ref<Subcategory>({
      cover: "", name: { it : '' }
    })

    const loadData = async () => {
      loading.value = true;
      let id = route.params.id as string;
      const res = await api.get<Subcategory>('subcategories', id)
      if(!res.success) {
        loading.value = false;
        messages.error(res.message ?? Msg.serverError)
        await router.replace('/subcategories')
        return
      }
      editingItem.value = res.data!
      loading.value = false;
    }

    onMounted(async ()=>{
      await globals.waitForInit
      await router.isReady()
      if (route.params.id !== "new") {
        await loadData();
      }
    })




    return {
      fileInput,
      form,
      loading,
      isEditing : computed(()=> route.params.id !== "new"),
      editingItem,
      rules,
      formatDate : utils.formatDate,
      cover: computed(()=>{
        if(file.value) {
          return URL.createObjectURL(file.value)
        }
        return editingItem.value.cover
      }),
      onFileChange() {
        if(fileInput.value!.files?.length) {
          file.value = fileInput.value!.files[0]!
        }
      },
      async save(goBackAfterSave:boolean) {
        const v = await form.value!.validate()
        if(!v.valid) return;
        loading.value = true;
        const res = await api.save<Subcategory>('subcategories', editingItem.value)
        if(!res.success) {
          messages.error(res.message ?? Msg.serverError)
          if(res.status === 401) {
            auth.logout()
          }
          return
        }
        editingItem.value = res.data!

        if(file.value) {
          const formData = new FormData()
          formData.append('file', file.value)

          const res2 = await api.upload<Subcategory>(`subcategories/${editingItem.value!._id}/cover`, formData)
          if(!res2.success) {
            messages.error(`sottocategoria prodotto salvata con errore upload: ${res2.message ?? Msg.serverError}`)
          } else {
            editingItem.value = res2.data!
            messages.success("sottocategoria prodotto salvata")
          }
          file.value = undefined
        } else {
          messages.success("sottocategoria prodotto salvata")
        }
        
        

        if(goBackAfterSave) {
          await router.replace('/subcategories')
        } else if(route.params.id === 'new'){
          await router.replace(`/subcategories/${editingItem.value._id}`)
        }
      }
    };
  }
};
</script>

<style scoped></style>
